import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const HorizontalBarsContent = ({ data }) => {

    const charts = [
        {
            key: "status",
            title: "Status",
            elementId: "solicitation-status",
            data: (data?.status ?? []).map(item => ({
                label: item.label,
                qty: Number(item.value)
            }))
        },
        {
            key: "description",
            title: "Descrição da solicitação",
            elementId: "solicitation-description",
            data: (data?.description ?? []).map(item => ({
                label: item.label,
                qty: Number(item.value)
            }))
        },
        {
            key: "user_observation",
            title: "Observação do agente",
            elementId: "solicitation-user-observation",
            data: (data?.user_observation ?? []).map(item => ({
                label: item.label,
                qty: Number(item.value)
            }))
        },
        {
            key: "attaches",
            title: "Anexos",
            elementId: "solicitation-attaches",
            data: (data?.attaches ?? []).map(item => ({
                label: item.label,
                qty: Number(item.value)
            }))
        }
    ];

    useEffect(() => {
        charts.forEach(chart => {
            GraphicUtils.horizontalStackedBarChart(chart.data, chart.elementId, "label");
        });
    }, [data]);

    return (
        <>
            {charts.map(chart => (
                <React.Fragment key={chart.key}>
                    <div className="chart-report">
                        <span className="chart-title">{(chart.title)}</span>
                        <div className="mt-1" id={chart.elementId}/>
                    </div>

                    <div className="chart-divisor"/>
                </React.Fragment>
            ))}
        </>
    );
};

export default HorizontalBarsContent;